import { baseBackend } from "../../../../api/base/baseUrl";

const RATES_ENTERPRISE_CITY_URL = "/api/v2/rates/enterprise_city";

export async function getRatesEnterpriseCityByEnterpriseRequest(enterpriseId) {
  const response = await baseBackend.get(
    `${RATES_ENTERPRISE_CITY_URL}/enterprise/${enterpriseId}`,
  );
  return response.data;
}

export async function getRatesEnterpriseCityByIdRequest(id) {
  const response = await baseBackend.get(`${RATES_ENTERPRISE_CITY_URL}/id/${id}`);
  return response.data;
}

export async function createRatesEnterpriseCityRequest(payload) {
  const response = await baseBackend.post(RATES_ENTERPRISE_CITY_URL, payload);
  return response.data;
}

export async function updateRatesEnterpriseCityRequest(payload) {
  const response = await baseBackend.put(RATES_ENTERPRISE_CITY_URL, payload);
  return response.data;
}

export async function deleteRatesEnterpriseCityRequest(id) {
  const response = await baseBackend.delete(
    `${RATES_ENTERPRISE_CITY_URL}/id/${id}`,
  );
  return response.data;
}
